import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { Card, Button, Header, Modal } from "semantic-ui-react";
import { Link } from "react-router";
import "../../styles/dashboard.scss";

class AdminFields extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / Administer Fields";
  }

  render() {
    if (this.props.userRole === "admin") {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Fields Admin
          </Header>
          <p className="white-text">Select a context to begin...</p>
          <Header as="h2" className="white-text">
            Records
          </Header>
          <Card.Group>
            <Card>
              <Card.Content>
                <Card.Header>Client Fields</Card.Header>
                <Card.Meta>Manage fields for client records.</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Link to="/admin/fields/client">
                  <Button content="Edit Fields" />
                </Link>
              </Card.Content>
            </Card>
            <Card>
              <Card.Content>
                <Card.Header>RFP Fields</Card.Header>
                <Card.Meta>Manage fields for RFP records.</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Link to="/admin/fields/rfp">
                  <Button content="Edit Fields" />
                </Link>
              </Card.Content>
            </Card>
            <Card>
              <Card.Content>
                <Card.Header>IO Fields</Card.Header>
                <Card.Meta>Manage fields for IO records.</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Link to="/admin/fields/io">
                  <Button content="Edit Fields" />
                </Link>
              </Card.Content>
            </Card>
          </Card.Group>
          <Header as="h2" className="white-text">
            Products & Services
          </Header>
          <Card.Group>
            {Flagship.config.lineItemServices.map(function(item, i) {
              if (item.hasOwnProperty("subOptions")) {
                return (
                  <Card key={"field-" + i}>
                    <Card.Content>
                      <Card.Header>{item.text}</Card.Header>
                    </Card.Content>
                    <Card.Content extra>
                      <h4 style={{ marginBottom: ".5em" }}>All {item.text}</h4>
                      <Link to={"/admin/fields/line_item-" + item.value}>
                        <Button content="RFP Fields" />
                      </Link>
                      <Link to={"/admin/fields/io-product-" + item.value}>
                        <Button content="IO Fields" />
                      </Link>
                    </Card.Content>
                    <Modal
                      closeIcon
                      trigger={<Button>Sub-Service Fields...</Button>}
                    >
                      <Card.Header>{item.text} Sub-Service Fields</Card.Header>
                      {item.subOptions.map(function(subItem, j) {
                        return (
                          <Card.Content key={"sub-item-" + j} extra>
                            <h4 style={{ marginBottom: ".5em" }}>
                              {subItem.text}
                            </h4>
                            <Link
                              to={"/admin/fields/line_item-" + subItem.value}
                            >
                              <Button content="RFP Fields" />
                            </Link>
                            <Link
                              to={"/admin/fields/io-product-" + subItem.value}
                            >
                              <Button content="IO Fields" />
                            </Link>
                          </Card.Content>
                        );
                      })}
                    </Modal>
                  </Card>
                );
              }

              return (
                <Card key={"field-" + i}>
                  <Card.Content>
                    <Card.Header>{item.text}</Card.Header>
                  </Card.Content>
                  <Card.Content extra>
                    <h4 style={{ marginBottom: ".5em" }}>{item.text}</h4>
                    <Link to={"/admin/fields/line_item-" + item.value}>
                      <Button content="RFP Fields" />
                    </Link>
                    <Link to={"/admin/fields/io-product-" + item.value}>
                      <Button content="IO Fields" />
                    </Link>
                  </Card.Content>
                  <Button
                    style={{ backgroundColor: "#ffffff", cursor: "default" }}
                  >
                    &nbsp;
                  </Button>
                </Card>
              );
            })}
          </Card.Group>
          <div id="footer">Flagship Administration</div>
        </div>
      );
    } else {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Administration
          </Header>
          <p className="white-text">
            You do not have access to administer Flagship.
          </p>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId
  };
}

export default connect(mapStateToProps, null)(AdminFields);



// WEBPACK FOOTER //
// ./src/components/admin/AdminFields.js